import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
@Component({
  selector: 'app-user-visit',
  templateUrl: './user-visit.component.html',
  styleUrls: ['./user-visit.component.scss'],
})
export class UserVisitComponent implements OnInit {
  storeList: any;
  page: any = 1;
  total: any = 0;
  pageSize = 10;
  selectedPage: any;
  count: number = 5;
  id: any = localStorage.getItem('managerId');
  role: any = localStorage.getItem('role');
  word: any = '';
  startDate: any = '';
  endDate: any = '';
  date: any;
  storeId: any;
  timeout: any = null;
  userVisitData: any;
  selectedUser: any = null;

  constructor(
    private service: ApiService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    public route: Router
  ) {}

  ngOnInit() {
    this.restoreStateFromQueryParams();
    this.getUserVisit();
    this.getStorelist();
  }

  private restoreStateFromQueryParams(): void {
    const q = this.activatedRoute.snapshot.queryParamMap;
    const pageParam = q.get('page');
    if (pageParam) {
      const p = parseInt(pageParam, 10);
      if (!isNaN(p) && p >= 1) {
        this.page = p;
        this.selectedPage = p;
      }
    }
    const wordParam = q.get('word');
    if (wordParam != null) {
      this.word = wordParam;
    }
    const storeIdParam = q.get('storeId');
    if (storeIdParam) {
      this.storeId = storeIdParam;
    }
    const startDateParam = q.get('startDate');
    const endDateParam = q.get('endDate');
    if (
      startDateParam &&
      endDateParam &&
      moment(startDateParam, 'YYYY-MM-DD', true).isValid() &&
      moment(endDateParam, 'YYYY-MM-DD', true).isValid()
    ) {
      this.startDate = startDateParam;
      this.endDate = endDateParam;
      this.date = {
        start: moment(startDateParam, 'YYYY-MM-DD'),
        end: moment(endDateParam, 'YYYY-MM-DD'),
      };
    }
  }

  private syncUrl(): void {
    this.route.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        page: this.page > 1 ? this.page : null,
        word: this.word?.trim() || null,
        storeId: this.storeId || null,
        startDate: this.startDate || null,
        endDate: this.endDate || null,
      },
      replaceUrl: true,
    });
  }

  private applyFilters(): void {
    this.syncUrl();
    this.getUserVisit();
  }

  getStorelist() {
    if (this.role == 'manager' && this.id) {
      this.service
        .getRequest(`${ApiUrl.storeListManagerDropdown}${this.id}`)
        .subscribe((res: any) => {
          // console.log(res);
          this.storeList = res.response.data;
        });
    } else {
      this.service
        .getRequest(ApiUrl.storeListAdminDropdown)
        .subscribe((res: any) => {
          // console.log(res);
          this.storeList = res.response.data.storesData;
        });
    }
  }
  getUserVisit() {
    this.spinner.show();
    const encodedWord = encodeURIComponent(this.word ?? '');
    if (this.role == 'manager' && this.id) {
      let apiUrl =
        `${ApiUrl.getUserVisitById}${this.id}?page=${this.page}&word=${encodedWord}&startDate=` +
        this.startDate +
        `&endDate=` +
        this.endDate;
      if (this.storeId) {
        apiUrl += `&storeId=${this.storeId}`;
      }
      this.service.getRequest(apiUrl).subscribe(
        (res: any) => {
          // console.log(res, "datawithid......")
          this.userVisitData = res.response?.data.visits;
          this.total = res.response.data.storeVisitCount;
          this.spinner.hide();
        },
        (err) => {
          this.spinner.hide();
        }
      );
    } else {
      let apiUrl =
        `${ApiUrl.getUserVisit}?page=${this.page}&word=${encodedWord}&startDate=` +
        this.startDate +
        `&endDate=` +
        this.endDate;
      if (this.storeId) {
        apiUrl += `&storeId=${this.storeId}`;
      }
      this.service.getRequest(apiUrl).subscribe(
        (res: any) => {
          // console.log(res, "uservisit...")
          this.userVisitData = res.response.data?.storeData;
          this.total = res.response.data.userVisitDataCount;
          this.spinner.hide();
        },
        (err) => {
          this.spinner.hide();
        }
      );
    }
  }

  // getUniqueStoreNames(userVisitData: any[]): any[] {
  //   const uniqueStoreNames = userVisitData?.reduce((uniqueNames, data) => {
  //     const storeId = data.storeData._id;
  //     if (
  //       !uniqueNames.some(
  //         (name: { storeData: { _id: any } }) => name.storeData._id === storeId
  //       )
  //     ) {
  //       uniqueNames.push(data);
  //     }
  //     return uniqueNames;
  //   }, []);
  //   return uniqueStoreNames;
  // }

  pageChanged(event: any) {
    this.page = event;
    this.selectedPage = event;
    this.applyFilters();
  }

  onFilterKeySearch() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.page = 1;
      this.applyFilters();
    }, 1000);
  }
  clearDate() {
    this.startDate = '';
    this.endDate = '';
    this.date = null;
    this.page = 1;
    this.applyFilters();
  }
  updateRangeDate(event: any) {
    if (event.start && event.end) {
      this.startDate = moment(event.start).startOf('day').format('YYYY-MM-DD');
      this.endDate = moment(event.end).endOf('day').format('YYYY-MM-DD');
      this.page = 1;
      this.applyFilters();
    }
  }
  onUserSelect(data: any) {
    if (!data?.userData?._id) {
      return;
    }
    this.selectedUser = data;
    this.route.navigate(['edituser', data.userData._id], {
      queryParams: { returnUrl: this.route.url },
    });
  }

  onStoreSelection() {
    // console.log(this.storeId, "Selected storeId");
    this.page = 1;
    this.applyFilters();
  }
}
